import { useEffect, useState } from "react";
import { signContentApi } from "../api/services";
import { mergeSignContent, SIGN_FALLBACKS } from "../constants/signDefaults";

export function useSignContent() {
  const [content, setContent] = useState(SIGN_FALLBACKS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    signContentApi
      .get()
      .then((res) => {
        if (!cancelled) {
          setContent(mergeSignContent(res.data.data.content));
        }
      })
      .catch(() => {
        if (!cancelled) setContent(SIGN_FALLBACKS);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { content, loading };
}
